export const API_URL = "https://muud.ly";
